// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"188":"05a270ef","594":"116a2096","645":"d56169ee","864":"eaa9e3f3"}[chunkId] + ".js";
};